(function () {
  "use strict";

  if (!window.DNB) {
    return;
  }

  window.DNB.register(function () {
    var modal = document.querySelector("[data-apply-modal]");
    var openButtons = document.querySelectorAll("[data-apply-open]");
    var closeButtons = document.querySelectorAll("[data-apply-close]");
    var panel = modal ? modal.querySelector(".apply-modal__panel") : null;
    var lastFocus = null;
    var alertModal = null;
    var alertPanel = null;
    var alertTitle = null;
    var alertMessage = null;
    var alertLastFocus = null;

    var setModalState = function (shouldOpen) {
      if (!modal) {
        return;
      }

      if (shouldOpen) {
        lastFocus = document.activeElement;
        modal.classList.add("is-open");
        modal.setAttribute("aria-hidden", "false");
        document.body.classList.add("is-modal-open");
        if (panel) {
          panel.focus();
        }
        return;
      }

      modal.classList.remove("is-open");
      modal.setAttribute("aria-hidden", "true");
      document.body.classList.remove("is-modal-open");
      if (lastFocus && typeof lastFocus.focus === "function") {
        lastFocus.focus();
      }
    };

    var ensureAlertModal = function () {
      if (alertModal) {
        return;
      }

      alertModal = document.querySelector("[data-apply-alert-modal]");
      if (!alertModal) {
        alertModal = document.createElement("div");
        alertModal.className = "apply-modal apply-alert-modal";
        alertModal.setAttribute("data-apply-alert-modal", "");
        alertModal.setAttribute("aria-hidden", "true");
        alertModal.innerHTML =
          '<button class="apply-modal__overlay" type="button" data-apply-alert-close aria-label="Close"></button>' +
          '<div class="apply-modal__panel apply-alert-modal__panel" role="dialog" aria-modal="true" aria-labelledby="apply-alert-title" tabindex="-1">' +
          '<button class="apply-modal__close" type="button" data-apply-alert-close aria-label="Close">x</button>' +
          '<div class="apply-alert-modal__inner">' +
          '<p class="apply-alert-modal__title" id="apply-alert-title" data-apply-alert-title>Notice</p>' +
          '<p class="apply-alert-modal__message" data-apply-alert-message></p>' +
          '<div class="apply-alert-modal__actions">' +
          '<button class="btn btn--primary" type="button" data-apply-alert-close>CLOSE</button>' +
          "</div>" +
          "</div>" + 
          "</div>";
        document.body.appendChild(alertModal);
      }

      alertPanel = alertModal.querySelector(".apply-modal__panel");
      alertTitle = alertModal.querySelector("[data-apply-alert-title]");
      alertMessage = alertModal.querySelector("[data-apply-alert-message]");

      var alertCloseButtons = alertModal.querySelectorAll("[data-apply-alert-close]");
      alertCloseButtons.forEach(function (button) {
        button.addEventListener("click", function () {
          setAlertState(false);
        });
      });
    };

    var setAlertState = function (shouldOpen, options) {
      ensureAlertModal();
      if (!alertModal) {
        return;
      }

      if (shouldOpen) {
        alertLastFocus = document.activeElement;
        if (options && options.title && alertTitle) {
          alertTitle.textContent = options.title;
        }
        if (options && typeof options.message !== "undefined" && alertMessage) {
          alertMessage.textContent = options.message;
        }
        alertModal.classList.add("is-open");
        alertModal.setAttribute("aria-hidden", "false");
        document.body.classList.add("is-modal-open");
        if (alertPanel) {
          alertPanel.focus();
        }
        return;
      }

      alertModal.classList.remove("is-open");
      alertModal.setAttribute("aria-hidden", "true");
      if (!modal || !modal.classList.contains("is-open")) {
        document.body.classList.remove("is-modal-open");
      }
      if (alertLastFocus && typeof alertLastFocus.focus === "function") {
        alertLastFocus.focus();
      }
    };

    openButtons.forEach(function (button) {
      button.addEventListener("click", function (event) {
        event.preventDefault();
        setModalState(true);
      });
    });

    closeButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        setModalState(false);
      });
    });

    document.addEventListener("keydown", function (event) {
      if (event.key !== "Escape") {
        return;
      }

      if (alertModal && alertModal.classList.contains("is-open")) {
        setAlertState(false);
        return;
      }

      if (modal && modal.classList.contains("is-open")) {
        setModalState(false);
      }
    });

    var dropzone = document.querySelector("[data-dropzone]");
    var dropzoneText = dropzone ? dropzone.querySelector("[data-dropzone-text]") : null;
    var dropzoneDefault = dropzoneText ? dropzoneText.textContent : "";
    var fileInput = document.getElementById("resumeFile");

    var setDropzoneText = function (file) {
      if (!dropzone || !dropzoneText) {
        return;
      }
      if (!file) {
        dropzoneText.textContent = dropzoneDefault;
        dropzone.classList.remove("is-file");
        return;
      }
      dropzoneText.textContent = file.name;
      dropzone.classList.add("is-file");
    };

    if (dropzone && fileInput) {
      dropzone.addEventListener("click", function () {
        fileInput.click();
      });

      dropzone.addEventListener("dragover", function (event) {
        event.preventDefault();
        dropzone.classList.add("is-dragover");
      });

      dropzone.addEventListener("dragleave", function () {
        dropzone.classList.remove("is-dragover");
      });

      dropzone.addEventListener("drop", function (event) {
        event.preventDefault();
        dropzone.classList.remove("is-dragover");
        if (!event.dataTransfer || !event.dataTransfer.files || !event.dataTransfer.files.length) {
          return;
        }
        var file = event.dataTransfer.files[0];
        if (!file) {
          return;
        }
        if (window.DataTransfer) {
          var dataTransfer = new DataTransfer();
          dataTransfer.items.add(file);
          fileInput.files = dataTransfer.files;
        }
        setDropzoneText(file);
      });

      fileInput.addEventListener("change", function () {
        var file = fileInput.files && fileInput.files.length ? fileInput.files[0] : null;
        setDropzoneText(file);
      });
    }

    var form = document.getElementById("jobApplicationForm");
    var fullNameInput = document.getElementById("fullName");
    var emailInput = document.getElementById("email");
    var digitalCvInput = document.getElementById("digitalCvLink");
    var privacyInput = document.getElementById("privacyPolicyAccepted");
    var readLayoutMessage = function (id) {
      var field = document.getElementById(id);
      if (!field || typeof field.value !== "string") {
        return "";
      }
      return field.value.trim();
    };

    var successTitle = readLayoutMessage("save-job-application-success-title");
    var successMessage = readLayoutMessage("save-job-application-success-message");
    var errorTitle = readLayoutMessage("global-form-error-title");
    var errorMessage = readLayoutMessage("global-form-error-message");

    var getFieldWrapper = function (field) {
      if (!field || !field.closest) {
        return null;
      }
      return field.closest(".form-field");
    };

    var setFieldError = function (field, message) {
      var wrapper = getFieldWrapper(field);
      if (!wrapper) {
        return;
      }
      wrapper.classList.add("form-field--error");
      if (field && field.setAttribute) {
        field.setAttribute("aria-invalid", "true");
      }
    };

    var clearFieldError = function (field) {
      var wrapper = getFieldWrapper(field);
      if (!wrapper) {
        return;
      }
      wrapper.classList.remove("form-field--error");
      if (field && field.removeAttribute) {
        field.removeAttribute("aria-invalid");
      }
    };

    var clearAllErrors = function () {
      if (!form) {
        return;
      }
      var wrappers = form.querySelectorAll(".form-field--error");
      wrappers.forEach(function (wrapper) {
        wrapper.classList.remove("form-field--error");
      });
      [fullNameInput, emailInput, digitalCvInput, fileInput, privacyInput].forEach(function (field) {
        if (field && field.removeAttribute) {
          field.removeAttribute("aria-invalid");
        }
      });
    };

    var isValidEmail = function (value) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    };

    var isValidUrl = function (value) {
      if (!value) {
        return true;
      }
      try {
        var url = new URL(value);
        return !!url.protocol && !!url.hostname;
      } catch (error) {
        return false;
      }
    };

    var validateForm = function () {
      clearAllErrors();
      var isValid = true;
      var fullName = fullNameInput ? fullNameInput.value.trim() : "";
      var email = emailInput ? emailInput.value.trim() : "";
      var digitalLink = digitalCvInput ? digitalCvInput.value.trim() : "";
      var hasFile = fileInput && fileInput.files && fileInput.files.length > 0;

      if (!fullName) {
        setFieldError(fullNameInput, "Required");
        isValid = false;
      }

      if (!email) {
        setFieldError(emailInput, "Required");
        isValid = false;
      } else if (!isValidEmail(email)) {
        setFieldError(emailInput, "Invalid email");
        isValid = false;
      }

      if (!digitalLink && !hasFile) {
        setFieldError(digitalCvInput, "Add a link or file");
        setFieldError(fileInput, "Add a file or link");
        isValid = false;
      } else if (digitalLink && !isValidUrl(digitalLink)) {
        setFieldError(digitalCvInput, "Invalid link");
        isValid = false;
      }

      if (privacyInput && !privacyInput.checked) {
        setFieldError(privacyInput, "Required");
        isValid = false;
      }

      return isValid;
    };

    var sanitizeNameValue = function (value) {
      if (!value) {
        return "";
      }
      try {
        return value.replace(/[^\p{L}\s]/gu, "");
      } catch (error) {
        return value.replace(/[^A-Za-zÀ-ÖØ-öø-ÿĞğİıŞşÇçÖöÜü\s]/g, "");
      }
    };

    if (fullNameInput) {
      fullNameInput.addEventListener("input", function () {
        var sanitized = sanitizeNameValue(fullNameInput.value);
        if (sanitized !== fullNameInput.value) {
          fullNameInput.value = sanitized;
        }
        clearFieldError(fullNameInput);
      });
    }

    if (emailInput) {
      emailInput.addEventListener("input", function () {
        clearFieldError(emailInput);
      });
    }

    if (digitalCvInput) {
      digitalCvInput.addEventListener("input", function () {
        clearFieldError(digitalCvInput);
      });
    }

    if (privacyInput) {
      privacyInput.addEventListener("change", function () {
        clearFieldError(privacyInput);
      });
    }

    if (fileInput) {
      fileInput.addEventListener("change", function () {
        clearFieldError(fileInput);
        if (digitalCvInput) {
          clearFieldError(digitalCvInput);
        }
      });
    }

    if (!window.jQuery || !form) {
      return;
    }

    var $ = window.jQuery;

    $(document).ready(function () {
      $("#jobApplicationForm").on("submit", function (e) {
        e.preventDefault();

        if (!validateForm()) {
          return;
        }

        var fullName = $("#fullName").val();
        var email = $("#email").val();
        var digitalCvLink = $("#digitalCvLink").val();
        var resumeFile = $("#resumeFile")[0].files[0];
        var applicationId = $("#applicationId").val();
        var referenceTitle = $("#referenceTitle").val();
        var privacyPolicyAccepted = $("#privacyPolicyAccepted").is(":checked");

        var formData = new FormData();
        formData.append("FullName", fullName);
        formData.append("Email", email);
        if (digitalCvLink) {
          formData.append("DigitalCvLink", digitalCvLink);
        }
        if (resumeFile) {
          formData.append("ResumeFile", resumeFile);
        }
        if (applicationId) {
          formData.append("ApplicationId", applicationId);
        }
        if (referenceTitle) {
          formData.append("ReferenceTitle", referenceTitle);
        }
        formData.append("PrivacyPolicyAccepted", privacyPolicyAccepted);

        var $submit = $("#submitBtn");
        var $submitLabel = $submit.find(".btn__label");
        $submit.prop("disabled", true);
        if ($submitLabel.length) {
          $submitLabel.text("SUBMITTING");
        }

        var sendJobApplication = function (recaptchaToken) {
          if (recaptchaToken) {
            formData.append("RecaptchaToken", recaptchaToken);
          }
          $.ajax({
            url: "/save-job-application",
            type: "POST",
            data: formData,
            processData: false,
            contentType: false,
            success: function (response) {
            if (response.success) {
              setModalState(false);
              setAlertState(true, {
                title: successTitle,
                message: successMessage
              });
              $("#jobApplicationForm")[0].reset();
              clearAllErrors();
              setDropzoneText(null);
            } else {
              setAlertState(true, {
                title: errorTitle,
                message: (response && response.message) ? response.message : errorMessage
              });
            }
          },
          error: function (xhr, status, error) {
            console.error("Error:", error);
            setAlertState(true, {
              title: errorTitle,
              message: errorMessage
            });
          },
          complete: function () {
            $submit.prop("disabled", false);
            if ($submitLabel.length) {
              $submitLabel.text("SUBMIT");
            }
          }
          });
        };

        if (typeof grecaptcha !== "undefined" && grecaptcha.enterprise) {
          grecaptcha.enterprise.ready(function () {
            grecaptcha.enterprise.execute("6LczYmYsAAAAABdWdlW9_LB3KaM53lJVbHJzm0e7", { action: "JOB_APPLICATION" })
              .then(function (token) {
                sendJobApplication(token);
              })
              .catch(function () {
                $submit.prop("disabled", false);
                if ($submitLabel.length) $submitLabel.text("SUBMIT");
                setAlertState(true, { title: errorTitle, message: "Güvenlik doğrulaması alınamadı. Lütfen sayfayı yenileyip tekrar deneyiniz." });
              });
          });
        } else {
          $submit.prop("disabled", false);
          if ($submitLabel.length) $submitLabel.text("SUBMIT");
          setAlertState(true, { title: errorTitle, message: "Güvenlik doğrulaması yüklenemedi. Lütfen sayfayı yenileyin." });
        }
      });
    });
  });
})();
